<div *ngIf="memberInfo$ | async as memberInfo">
  <!--Banner-->
  <fgb-home-page-banner
    [isKid]="isKid"
    [isClub1901]="isClub1901"
    [isSTHMember]="isSTHMember"
    [memberInfo]="memberInfo"
  ></fgb-home-page-banner>

  <!--Mobile Barcode-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <fgb-home-navigation></fgb-home-navigation>
  </ng-container>
</div>

<div class="mobile-page-content">
  <!--Loyalty Feed-->
  <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>

  <!--Scorecard carousel-->
  <div class="animate-in delay-1">
    <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
  </div>

  @if (isClub1901) {
  <div class="container pt-4 animate-in delay-2">
    <ng-container *ifScreenSize="screenSize.Desktop">
      <a [routerLink]="'/brand'">
        <img class="offers-widget w-100 h-100" [src]="'1901/1901-offers.png' | contentAssetImage" />
      </a>
    </ng-container>
    <ng-container *ifScreenSize="screenSize.Mobile">
      <a [routerLink]="'/brand'">
        <img class="offers-widget w-100" style="height: 366px" [src]="'1901/1901-offers-mobile.png' | contentAssetImage" />
      </a>
    </ng-container>
  </div>
  } @if (!isClub1901) {
  <div class="container pt-4 animate-in delay-2">
    <!--Vouchers-->
    <fgb-vouchers></fgb-vouchers>
  </div>
  }

  <div
    class="container d-flex flex-column animate-in delay-3"
    [ngClass]="{
      'flex-column-reverse': isKid
    }"
  >
    <!-- Featured Rewards -->
    <fgbcl-featured-rewards [showAllPath]="'/rewards/raffles'"></fgbcl-featured-rewards>

    @if (isClub1901) {
    <div class="mt-4">
      <!--Vouchers-->
      <fgb-vouchers></fgb-vouchers>
    </div>
    }

    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>

    <!-- Widgets -->
    <div class="widget-container animate-in delay-4">
      <div class="home-widgets pt-4">
        @if (isSTHMember) {
        <ng-container *hasTag="tags.AdultMembers; checkValue: false">
          <div (click)="launchShop(shopURL)">
            <img class="widget shop-widget cursor-pointer" [src]="'member/widgets/shop.png' | contentAssetImage" />
          </div>
        </ng-container>

        <ng-container *hasTag="tags.AdultSTH; checkValue: false">
          <div [routerLink]="['/games/arcade']">
            <img class="widget shop-widget cursor-pointer" [src]="'widgets/arcade.png' | contentAssetImage" />
          </div>
        </ng-container>

        <a [routerLink]="'/tv'">
          <img class="widget tv-widget" [src]="'widgets/latest.png' | contentAssetImage" />
        </a>

        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
          <ng-container *ifScreenSize="screenSize.Mobile">
            <a [routerLink]="'/brand'">
              <img class="widget w-100 h-100" [src]="'widgets/offers.png' | contentAssetImage" />
            </a>
          </ng-container>
        </ng-container>
        } @if (isKid) {
        <ng-container *ngIf="memberInfo$ | async as memberInfo">
          <ng-container *ngIf="memberInfo.kidType == 'All-Stars'">
            <a [routerLink]="'/games/arcade'">
              <img class="widget" [src]="'widgets/allstar-arcade.png' | contentAssetImage" />
            </a>

            <a [routerLink]="'/tv'">
              <img class="widget" [src]="'widgets/allstar-latest.png' | contentAssetImage" />
            </a>
          </ng-container>
          <ng-container *ngIf="memberInfo.kidType == 'Junior'">
            <a [routerLink]="'/games/arcade'">
              <img class="widget" [src]="'widgets/baller-arcade.png' | contentAssetImage" />
            </a>

            <a [routerLink]="'/tv'">
              <img class="widget" [src]="'widgets/baller-latest.png' | contentAssetImage" />
            </a>
          </ng-container>
        </ng-container>
        }
      </div>
      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
        @if (isSTHMember) {
        <ng-container *ifScreenSize="screenSize.Desktop">
          <a [routerLink]="'/brand'">
            <img class="offers-widget w-100 h-100 mt-4" [src]="'widgets/offers.png' | contentAssetImage" />
          </a>
        </ng-container>
        }
      </ng-container>

      @if (isClub1901) {
      <a [routerLink]="'/tv'">
        <img class="offers-widget w-100 h-100 mt-4" [src]="'1901/1901-latest.png' | contentAssetImage" />
      </a>
      }
    </div>
  </div>
</div>
